import _ from "underscore"
import TabsController from "../TabsController"
import TaskPanelDetails from "./TaskPanelDetails"
import Header from "./Header"
import ReportedTime from "./reportedTime/ReportedTime"
import MoveToDialog from "../MoveToDialog"
import AssignedUsersEditor from "../usersAssignedToHierarchy/AssignedUsersEditor"
import messageResource from "../../messageResource"
import LoadingContainer from "../../util/LoadingContainer"
import AssignedUsersEditorContainer from "../usersAssignedToHierarchy/AssignedUsersEditorContainer"
import DeleteTaskPopupConfirmationDialog from "../../cptManagement/deleteConfirmationDialog/DeleteTaskPopupConfirmationDialog"
import TemplateView from "../../TemplateView"
import ScrollableContainer from '../../util/ScrollableContainer'
import CommentsFooter from '../comments/CommentsFooter'
import CreateFooter from '../CreateFooter'
import {ReportedTimeSortConstants, TaskDialogs, TasksTabs} from './constants'
import {setEventPreventHidingEditTaskSlidingPanel} from '../utils'
import InformationBlock from '../../components/informationBlock/InformationBlock'
import UserNameFormat from '../../util/UserNameFormat'
import CopySettingsBlock from '../components/CopySettingsBlock'
import {getItemsForCopyTaskSettingsBlock} from '../components/utils'
import MoveToArchivedConfirmationDialog from '../MoveToArchivedConfirmationDialog'

export default class TaskPanel extends TemplateView {
    constructor({
        additionalClass = "",
        canEdit = false,

        showCreateFooter = false,
        showComments = false,
        showActions = false,
        showReportTab = false,
        showEmptyTaskNameInput = false,

        dateFormat,
        // callbacks
        onTaskMovedCb = taskId => {},
        onTaskDeletedCb = () => {},
        // actions
        saveComment = () => {},
        saveEditingComment = () => {},
        toggleNewCommentInput = () => {},
        updateNewCommentText = () => {},
        closeTaskPanel = () => {},
        setTaskPanelTab = () => {},
        setLastTaskPanelTab = () => {},
        openLastTaskPanelTab = () => {},

        updateStatus = () => {},
        updateName = () => {},
        updateDeadline = () => {},
        updateTypeOfWork = () => {},
        updateEstimate = () => {},
        updateDescription = () => {},

        createTask = () => {},
        deleteTask = () => {},
        moveTask = () => {},
        copyTask = () => {},
        resetDeletionStatus = () => {},

        deleteAssignedUser = (userId) => {},
        updateAssignedUsers = () => {},
        deleteAssignedManager = () => {},
        updateAssignedManagers = () => {},

        loadTaskAuditHistory = () => {},

        loadTimeComments = () => {},
        saveSortingSettings = () => {},

        toast = (text) => {},
    }) {
        super()
        this.updateOnInit = false

        this.params = {
            canEdit,
            additionalClass,
            dateFormat,

            showCreateFooter,
            showComments,
            showActions,
            showReportTab,
            showEmptyTaskNameInput,
        }

        this.callbacks = {
            onTaskDeletedCb,
            onTaskMovedCb,
        }

        this.actions = {
            saveComment,
            saveEditingComment,
            toggleNewCommentInput,
            updateNewCommentText,
            closeTaskPanel,
            setTaskPanelTab,
            setLastTaskPanelTab,
            openLastTaskPanelTab,
            updateStatus,
            updateName,
            updateDeadline,
            updateTypeOfWork,
            updateEstimate,
            updateDescription,
            createTask,
            deleteTask,
            moveTask,
            copyTask,
            resetDeletionStatus,
            deleteAssignedUser,
            updateAssignedUsers,
            deleteAssignedManager,
            updateAssignedManagers,
            loadTaskAuditHistory,
            loadTimeComments,
            saveSortingSettings,
            toast,
        }

        this.state = {
            currentTabKey: TasksTabs.DETAILS_TAB,
            lastSelectedTabKey: TasksTabs.DETAILS_TAB,
            loggedInUser: null,
            sendingComment: false,
            showNewCommentInput: false,
            newCommentText: '',

            canEdit: canEdit,
            openTaskId: null,
            loading: false,
            projectName: '',
            customerName: '',

            completed: false,
            workflowStatusId: 0,
            name: '',
            deadline: null,
            typeOfWork: null,
            estimatedTime: 0,
            spentTime: 0,
            description: '',
            commentsCount: 0,

            nameUpdating: false,
            deadlineUpdating: false,
            typeOfWorkUpdating: false,
            descriptionUpdating: false,
            estimateUpdating: false,
            statusUpdating: false,
            moveToDialogLoading: false,

            errors: {},

            isBTYEnabled: false,
            isURAEnabled: false,
            isTWSEnabled: false,
            isESTEnabled: false,
            isWASEnabled: false,
            isTTAEnabled: false,

            assignedUsers: [],
            assignedManagers: [],
            userGroupsEnabled: true,
            timeZoneGroupsEnabled: true,
            userGroups: [],
            timeZoneGroups: [],
            canModifyAnyUser: false,
            canModifyAnyManager: false,

            taskDetails: {},
            taskDeletedSuccessfully: false,
            taskDeletedUnsuccessfully: false,

            copyMoveSelectorsCustomerIds: {},
            copyMoveSelectorsProjectIds: {},
            editableCustomersIds: {},
            editableProjectsIds: {},

            auditActions: [],
            lastAuditActions: {
                createAction: null,
                updateAction: null,
            },
            allAuditHistoryLoaded: false,

            canReopenProject: false,
            canMoveTask: true,
            canGenerateMoneyReports: false,
            canManageAccountsAndPermissions: false,
            hasManageScopeRights: false,
            taskInManageAssignments: false,

            executorsSummary: {
                total: null,
                myRecord: null,
                myTeamRecords: [],
                othersRecords: [],
                myTeamTotal: 0,
                othersTotal: 0,
            },
            reportedTimeComments: [],
            allTimeCommentsLoaded: false,
            timeAndCommentsLoading: false,
            sortingSettings: {
                sortBy: null,
                sortOrder: null,
            },

            isNeedInitializeFocus: false,

            defaultCompletedStatus: {},

            hasSomeTeamAssignment: false,
        }

        this.onStatePropertyChanged('isNeedInitializeFocus', (isNeedInitializeFocus) => {
            this.header.setState({isNeedInitializeFocus: isNeedInitializeFocus})
        })

        this.onStatePropertyChanged('currentTabKey', this._handleTabSwitched)

        this.onAnyStatePropertyChanged(['loggedInUser', 'sendingComment', 'showNewCommentInput', 'newCommentText'], (state) => {
            this.commentsFooter.setState({
                loggedInUser: state.loggedInUser,
                sending: state.sendingComment,
                showNewCommentInput: state.showNewCommentInput,
                commentText: state.newCommentText,
            })
        })

        this.onAnyStatePropertyChanged(['name', 'nameUpdating', 'errors', 'projectName', 'customerName', 'canEdit'], (state) => {
            this.header.setState({
                name: state.name,
                projectName: state.projectName,
                customerName: state.customerName,
                editable: state.canEdit,
                nameLoading: state.nameUpdating,
                errors: state.errors,
            })
        })

        this.onAnyStatePropertyChanged(['errors'], (state) => {
            this.createFooter.setState({
                hasErrors: Object.keys(state.errors).length > 0,
            })
        })

        this.onStatePropertyChanged("openTaskId", (taskId) => {
            this.getTabView(TasksTabs.DETAILS_TAB).setState({
                id: taskId,
            })
            this.actions.openLastTaskPanelTab()
        })

        this.onStatePropertyChanged('spentTime', (spentTime) => {
            this.header.setReportedTime(spentTime)
        })

        this.onAnyStatePropertyChanged([
            'openTaskId', 'completed', 'workflowStatusId', 'deadline', 'typeOfWork', 'estimatedTime', 'spentTime', 'description', 'canReopenProject',
            'isBTYEnabled', 'isTWSEnabled', 'isESTEnabled',
            'deadlineUpdating', 'typeOfWorkUpdating', 'estimateUpdating', 'descriptionUpdating', 'statusUpdating', 'canGenerateMoneyReports',
            'taskInManageAssignments', 'auditActions', 'auditDependencies', 'lastAuditActions', 'allAuditHistoryLoaded'
        ], (state) => {
            this.getTabView(TasksTabs.DETAILS_TAB).setState({
                completed: state.completed,
                workflowStatusId: state.workflowStatusId,
                deadline: state.deadline,
                typeOfWork: state.typeOfWork,
                taskEstimatedTime: state.estimatedTime,
                taskSpentTime: state.spentTime,
                taskDescription: state.description,
                isBTYEnabled: state.isBTYEnabled,
                isTWSEnabled: state.isTWSEnabled,
                isESTEnabled: state.isESTEnabled,
                canReopenProject: state.canReopenProject,
                canGenerateMoneyReports: state.canGenerateMoneyReports,
                taskInManageAssignments: state.taskInManageAssignments,

                deadlineLoading: state.deadlineUpdating,
                typeOfWorkLoading: state.typeOfWorkUpdating,
                estimateLoading: state.estimateUpdating,
                taskDescriptionLoading: state.descriptionUpdating,
                statusLoading: state.statusUpdating,

                auditActions: state.auditActions,
                auditDependencies: state.auditDependencies,
                lastAuditActions: state.lastAuditActions,
                allAuditHistoryLoaded: state.allAuditHistoryLoaded,
            })
        })

        this.onStatePropertyChanged('estimatedTime', (time) => {
            this.reportedTime.updateEstimated(time)
        })

        this.onAnyStatePropertyChanged(['completed', 'moveToDialogLoading'], (state) => {
            this.moveToDialog.setLoading(state.moveToDialogLoading)
        })

        this.onAnyStatePropertyChanged(['copyMoveSelectorsProjectIds', 'copyMoveSelectorsCustomerIds'], (state) => {
            this.moveToDialog.setCustomersToMove(state.copyMoveSelectorsCustomerIds)
            this.moveToDialog.setProjectsToMove(state.copyMoveSelectorsProjectIds)
            this.copyToDialog.setCustomersToMove(state.copyMoveSelectorsCustomerIds)
            this.copyToDialog.setProjectsToMove(state.copyMoveSelectorsProjectIds)
        })

        this.onAnyStatePropertyChanged(
            [
                'canManageAccountsAndPermissions',
                'isBTYEnabled',
                'isESTEnabled',
                'isTWSEnabled',
                'isWASEnabled',
                'hasSomeTeamAssignment'
            ], () => {
            this.copySettingsBlock.setState(getItemsForCopyTaskSettingsBlock(this.state.canManageAccountsAndPermissions,
                this.state.isBTYEnabled,
                this.state.isESTEnabled,
                this.state.isTWSEnabled,
                this.state.isWASEnabled,
                this.state.hasSomeTeamAssignment,)
            )
        })

        this.onStatePropertyChanged('canEdit', editable => this.setEditable(editable))

        this.onStatePropertyChanged('openTaskId', (openTaskId) => {
            if (openTaskId !== null){
                if (this.state.currentTabKey === TasksTabs.REPORTED_TAB) {
                    this.reportedTimeScrollable.scrollToTop()
                } else if (this.state.currentTabKey === TaskDialogs.DETAILS_TAB
                           || this.state.currentTabKey === TaskDialogs.ASSIGNED_USERS_TAB
                           || this.state.currentTabKey === TaskDialogs.MANAGERS_TAB) {
                    this.getTabView(this.state.currentTabKey).scrollToTop()
                }
            }
        })

        this.onStatePropertyChanged('assignedManagers', managers => {
            this.managersEditorContainer.setState({users: managers})
        })

        this.onStatePropertyChanged('assignedUsers', users => {
            this.assignedUsersEditorContainer.setState({users})
        })

        // change state of assigned users tab
        this.onAnyStatePropertyChanged(['userGroupsEnabled', 'timeZoneGroupsEnabled', 'userGroups', 'timeZoneGroups', 'canModifyAnyUser', 'canEdit'],
            ({userGroupsEnabled, timeZoneGroupsEnabled, userGroups, timeZoneGroups, canModifyAnyUser, canEdit}) => {
                const data = {userGroupsEnabled, timeZoneGroupsEnabled, userGroups, timeZoneGroups,
                    canModifyAny : canModifyAnyUser,
                    hideAssignButton: !canEdit,
                }
                this.assignedUsersEditorContainer.setState(data)
            })

        // change state of assigned managers tab
        this.onAnyStatePropertyChanged(['userGroupsEnabled', 'timeZoneGroupsEnabled', 'userGroups', 'timeZoneGroups', 'canModifyAnyManager'],
            ({userGroupsEnabled, timeZoneGroupsEnabled, userGroups, timeZoneGroups, canModifyAnyManager}) => {
                const data = {userGroupsEnabled, timeZoneGroupsEnabled, userGroups, timeZoneGroups,
                    canModifyAny : canModifyAnyManager,
                    hideAssignButton: !canModifyAnyManager,
                }
                this.managersEditorContainer.setState(data)
            })

        this.onAnyStatePropertyChanged(['name', 'taskDetails'], ({name, taskDetails}) => {
            this.header.updateActions(taskDetails)
            this.updateDeleteDialog(name, taskDetails)
        })

        this.onStatePropertyBecameTrue('taskDeletedUnsuccessfully', () => {
            // this.header.actions.disableDeleteButton(message); //todo koshik message
            this.actions.openLastTaskPanelTab()
            this.actions.resetDeletionStatus()
        })

        this.onStatePropertyBecameTrue('taskDeletedSuccessfully', () => {
            this.callbacks.onTaskDeletedCb(this.state.openTaskId)
            this.actions.resetDeletionStatus()
        })

        this.onStatePropertyChanged('executorsSummary', () => {
            this.reportedTime.updateSummaryRecords(this.state.executorsSummary)
        })

        this.onStatePropertyChanged('timeAndCommentsLoading', timeAndCommentsLoading => {
            this.reportedTime.setTimeAndCommentsLoading(timeAndCommentsLoading)
        })

        this.onStatePropertyChanged('reportedTimeComments', reportedTimeComments => {
            this.reportedTime.clearTimeRows()
            this.reportedTime.updateTimeRows(reportedTimeComments)
            this.reportedTimeScrollable.forceUpdate()
        })

        this.onStatePropertyChanged('sortingSettings', sortingSettings => {
            this.reportedTime.setTableSettings(sortingSettings)
        })

        this.onAnyStatePropertyChanged(['isBTYEnabled', 'isURAEnabled', 'isTTAEnabled'], ({isBTYEnabled, isURAEnabled, isTTAEnabled}) => {
            this.managersEditorScrollable.setState({isBTYEnabled, isURAEnabled, isTTAEnabled})
        })

        this.onStatePropertyChanged('isWASEnabled', isWASEnabled => {
            this.buttons.get(TasksTabs.ASSIGNED_USERS_TAB).toggle(isWASEnabled)
            this._updateDialogsInfo()
        })

        this.onStatePropertyChanged('isTWSEnabled', isTWSEnabled => {
            this.archivingConfirmation.setState({
                isTWSEnabled: isTWSEnabled,
                archiveText: isTWSEnabled
                    ? messageResource.getMessage("task.list.move_to.move_to_archived.complete_with_status.single_task")
                    : messageResource.getMessage("task.list.move_to.move_to_archived.complete_with_status.single_task.feature_disabled"),
            })
        })
    }

    templateHtml() {
        return "<div class='taskPanelContent <%-additionalClass%>'>" +
               "  <div class='headerBlock'/>" +
               "  <div class='contentScrollableWrapper'>" +
               "    <div class='taskPanelInnerContent'/>" +
               "  </div>" +
               "  <div class='commentsFooterBlock'/>" +
               "  <div class='createFooterBlock'/>" +
               "</div>"
    }

    templateModel() {
        return {
            additionalClass: this.params.additionalClass
        }
    }

    update() {
        if (!this.state.currentTabKey) {
            this.actions.setTaskPanelTab(TasksTabs.DETAILS_TAB)
        }

        this.header.update();

        _.forEach(TasksTabs, (key) => {
            let tabView = this.getTabView(key)
            if (tabView) {
                tabView.update()
            }
        });
    }

    updateDeleteDialog(name, state) {
        if (!state.blockedDueToLockedTime && !state.blockedDueToUnavailableToModifyTimeTrack) {
            this.deleteDialog.setState({
                entityName: name,
                entitiesToDeleteCount: 1,
                entitiesBlocked: 0,
                entitiesBlockedCount: 0,
                entitiesBlockedDueToLockedTimeCount: 0,
                entitiesBlockedDueToUnavailableToModifyTimeTrackCount: 0,
                entitiesWithManagerTimeTrackCount: state.taskHasManagerTimeTrack ? 1 : 0,
                entitiesWithOtherUsersTimeTrackCount: state.taskHasOtherUsersTimeTrack ? 1 : 0,
                entitiesWithManagerApprovedTimeTrackCount: state.taskHasManagerApprovedTimeTrack ? 1 : 0,
                entitiesWithOtherUsersApprovedTimeTrackCount: state.taskHasOtherUsersApprovedTimeTrack ? 1 : 0,
                hasManagerApprover: state.hasManagerApprover
            });
            this.deleteDialogScrollable.update()
        }
    }

    setEditable(editable) {
        _.forEach(TasksTabs, (key) => {
            let tabView = this.getTabView(key)
            if (tabView && tabView.setEditable) {
                tabView.setEditable(editable)
            }
            tabView.setState({
                editable: editable,
            })
        });
    }

    afterRender() {
        this.$content = this.find(".taskPanelInnerContent")
        this.$header = this.find(".headerBlock")
        this.$contentWrapper = this.find('.contentScrollableWrapper');

        this.header = new Header(this.$header, this.$el,{
            editable: this.state.canEdit,
            showActions: this.params.showActions,
            showReportTab: this.params.showReportTab,
            showEmptyNameInput: this.params.showEmptyTaskNameInput,
            onChangeNameCb: this.actions.updateName,
            onTabSwitchedCb: (key) => this.actions.setTaskPanelTab(key),
        }).init();

        const assignedUsersEditor = new LoadingContainer({
            contentComponent: new AssignedUsersEditor({
                onUserDelete: userData => this.actions.deleteAssignedUser(userData.id),
                onAssignedUsersChange: ({addedUserIds, removedUserIds}) => this.actions.updateAssignedUsers(addedUserIds, removedUserIds),
                titleMessageKey: "assigned_users_editor.task.title",
                userSubtitleGenerator: (user) => {
                    if (user.hasAllAssignments) {
                        return messageResource.getMessage("assigned_users_editor.task.has_all_assignments")
                    } else if (user.hasCustomerAssignment) {
                        return messageResource.getMessage("assigned_users_editor.task.has_customer_assignment")
                    } else if (user.hasProjectAssignment) {
                        return messageResource.getMessage("assigned_users_editor.task.has_project_assignment")
                    }
                },
                managersMessageKey: "assigned_users_editor.task.managers_count",
                canEditManagers: false,
                addUsersMessageKey: "assigned_users_editor.add_title",
                emptyListMessageKey: "assigned_users_editor.task.empty_list",
                showPermissionIcons: false,
                usersSelectorTitle: messageResource.getMessage("assigned_users_editor.task.users_selector_title"),
                renderUserSelectorToContent: true,
                refreshScrollCb: () => this.assignedUsersEditorScrollable.forceUpdate(),
                checkIfCanModify: user => !user.hasManageAssignment,
                getListDisabledTooltipText: user => this._getDisabledTooltipTextAssugnedUsersEditor(user),
                getSelectorDisabledTooltipText: user => this._getDisabledTooltipTextAssignedUsersSelector(user),
            }),
            containerClass: "assignedUsersTab panelTab"
        });
        this.assignedUsersEditorScrollable = new ScrollableContainer(null, assignedUsersEditor, {
            needRefreshOnResize: true,
            showScrollToTopButton: true,
            containerClass: 'assignedUsersScrollableContainer',
            triggerScrollEvent: true,
            iScrollParams: {
                probeType: 2
            },
        }).init(this.$content)
        this.assignedUsersEditorContainer = new AssignedUsersEditorContainer({
            assignedUsersEditor: this.assignedUsersEditorScrollable,
            $tabTitle: this.header.$assignedUsersTabTitle,
            tabTitleMessageKey: "task.edit_panel.tabs.assigned_users_with_count"
        }).init();

        const managersEditor = new LoadingContainer({
            contentComponent: new AssignedUsersEditor({
                onUserDelete: userData => {
                    this.actions.deleteAssignedManager(userData)
                    this._handleManagersRemovedToast([userData.id])
                },
                onAssignedUsersChange: ({addedUserIds, removedUserIds}) => {
                    this.actions.updateAssignedManagers(addedUserIds, removedUserIds)

                    if (!this.params.showCreateFooter) {
                        this._handleManagersRemovedToast(removedUserIds)
                    }
                },
                titleMessageKey: "assigned_users_editor.managers.task.title",
                userSubtitleGenerator: (user) => {
                    if (user.hasAllAssignments) {
                        return messageResource.getMessage("assigned_users_editor.managers.task.has_all_assignments")
                    } else if (user.hasCustomerAssignment) {
                        return messageResource.getMessage("assigned_users_editor.managers.task.has_customer_assignment")
                    } else if (user.hasProjectAssignment) {
                        return messageResource.getMessage("assigned_users_editor.managers.task.has_project_assignment")
                    }
                },
                addUsersMessageKey: "assigned_users_editor.managers.add_title",
                showPermissionIcons: true,
                usersSelectorTitle: messageResource.getMessage("assigned_users_editor.managers.task.users_selector_title"),
                renderUserSelectorToContent: true,
                refreshScrollCb: () => this.managersEditorScrollable.forceUpdate(),
                checkIfCanModify: user => !(user.hasAllAssignments ||
                                            user.hasCustomerAssignment ||
                                            user.hasAllFutureProjectsOfCustomerAssignment ||
                                            user.hasProjectAssignment ||
                                            user.hasAllFutureTasksOfProjectAssignment
                ),
                getListDisabledTooltipText: user => this._getDisabledTooltipText(user),
            }),
            containerClass: "managersTab panelTab"
        });
        this.managersEditorScrollable = new ScrollableContainer(null, managersEditor, {
            needRefreshOnResize: true,
            showScrollToTopButton: true,
            containerClass: 'assignedUsersScrollableContainer',
            triggerScrollEvent: true,
            iScrollParams: {
                probeType: 2
            },
        }).init(this.$content)
        this.managersEditorContainer = new AssignedUsersEditorContainer({
            assignedUsersEditor: this.managersEditorScrollable,
            $tabTitle: this.header.$managersTabTitle,
            tabTitleMessageKey: "task.edit_panel.tabs.managers_with_count"
        }).init();

        this._initMoveToDialog()
        this._initCopyToDialog()

        this.deleteDialog = new DeleteTaskPopupConfirmationDialog(
            this.$content,
            () => this.actions.openLastTaskPanelTab(),
            (revokeStatuses) => this.actions.deleteTask(revokeStatuses),
        ).init()
        this.deleteDialogScrollable = new ScrollableContainer(null, this.deleteDialog, {needRefreshOnResize : true}).init(this.$content);

        this.taskPanelDetails = new TaskPanelDetails({
            editable: this.state.canEdit,
            showComments: this.params.showComments,
            dateFormat: this.params.dateFormat,
            refreshScrollCb: () => this.taskPanelDetailsScrollable.forceUpdate(),
            scrollToElementCb: ($el, pos) => this.taskPanelDetailsScrollable.scrollToElementVertical($el, pos),
            onStatusChangedCb: id => this.actions.updateStatus(id),
            onDeadlineChangedCb: date => this.actions.updateDeadline(date),
            onTypeOfWorkChangedCb: id => this.actions.updateTypeOfWork(id),
            onEstimateChangedCb: time => this.actions.updateEstimate(time),
            onDescriptionChangeCb: text => this.actions.updateDescription(text),
            loadAuditHistoryCb: this.actions.loadTaskAuditHistory,
            onHistoryClickCb: e => setEventPreventHidingEditTaskSlidingPanel(e),
        })
        this.taskPanelDetailsScrollable = new ScrollableContainer(null,
            this.taskPanelDetails,
            {
                needRefreshOnResize: true,
                shouldUpdateOnInit: false,
                showScrollToTopButton: true,
                triggerScrollEvent: true,
                iScrollParams: {
                    probeType: 2
                }
            });
        this.taskPanelDetailsScrollable.init(this.$content)

        this.reportedTime = new ReportedTime(this.$content)
        this.reportedTimeScrollable = new ScrollableContainer(null,
            this.reportedTime,
            {
                needRefreshOnResize: true,
                shouldUpdateOnInit: false,
                showScrollToTopButton: true,
                triggerScrollEvent: true,
                onScrollToBottom: () => {
                    // TODO: this check should ideally be placed in redux actions, but this component is not ready for it yet
                    if (this.state.currentTabKey === TasksTabs.REPORTED_TAB && !this.state.allTimeCommentsLoaded) {
                        this.actions.loadTimeComments(
                            this.state.sortingSettings.sortBy,
                            this.state.sortingSettings.sortOrder,
                            this.state.reportedTimeComments.length
                        )
                    }
                },
                iScrollParams: {
                    probeType: 2
                },
            }).init(this.$content);

        this.tabs = new Map([
            [TasksTabs.DETAILS_TAB, this.taskPanelDetailsScrollable],
            [TasksTabs.REPORTED_TAB, this.reportedTimeScrollable],
            [TasksTabs.ASSIGNED_USERS_TAB, this.assignedUsersEditorScrollable],
            [TasksTabs.MANAGERS_TAB, this.managersEditorScrollable],
            [TaskDialogs.MOVE_DIALOG, this.moveToDialogScrollable],
            [TaskDialogs.COPY_DIALOG, this.copyToDialogScrollable],
            [TaskDialogs.DELETE_DIALOG, this.deleteDialogScrollable],
        ])

        this.commentsFooter = new CommentsFooter({
            onCommentTextChange: this.actions.updateNewCommentText,
            onShowInputChanged: this.actions.toggleNewCommentInput,
            onCommentAdded: this.actions.saveComment,
            refreshScrollCb: () => {
                this.taskPanelDetailsScrollable.performIfScrollToBottom(() => {
                    this.taskPanelDetailsScrollable.forceUpdate()
                    this.taskPanelDetailsScrollable.scrollToBottom()
                })
                this.taskPanelDetailsScrollable.forceUpdate()
            }
        }).init(this.find('.commentsFooterBlock'))
        this.commentsFooter.toggle(this.params.showComments)

        this.tabs.forEach(($tab, tabKey) => {
            $tab.hide()
        })

        this.tabsController = new TabsController({
            tabs: this.tabs,
        }).init()

        this.buttons = new Map([
            [TasksTabs.DETAILS_TAB, this.header.$tabs[TasksTabs.DETAILS_TAB]],
            [TasksTabs.REPORTED_TAB, this.header.$tabs[TasksTabs.REPORTED_TAB]],
            [TasksTabs.ASSIGNED_USERS_TAB, this.header.$tabs[TasksTabs.ASSIGNED_USERS_TAB]],
            [TasksTabs.MANAGERS_TAB, this.header.$tabs[TasksTabs.MANAGERS_TAB]],
            [TaskDialogs.DELETE_DIALOG, this.header.actions.menu.$delete],
            [TaskDialogs.MOVE_DIALOG, this.header.actions.menu.$move],
            [TaskDialogs.COPY_DIALOG, this.header.actions.menu.$copy],
        ])

        this.createFooter = new CreateFooter({
            additionalClass: 'taskPanel',
            submitBtnLabelMsgKey: 'task.create_panel.add_task',
            withPlusIcon: true,
            onSubmitCb: () => this.actions.createTask(),
            onCancelCb: () => this.actions.closeTaskPanel(),
        }).init(this.find('.createFooterBlock'))
        this.createFooter.toggle(this.params.showCreateFooter)

        this.reportedTime.dateHeader.on('click', () => this._reportedTimeSortChangedHandler(this.reportedTime.dateHeader))
        this.reportedTime.userHeader.on('click', () => this._reportedTimeSortChangedHandler(this.reportedTime.userHeader))
    }

    _initCopyToDialog() {
        this.copySettingsBlock = new CopySettingsBlock({
            ...getItemsForCopyTaskSettingsBlock(this.state.canManageAccountsAndPermissions,
                this.state.isBTYEnabled,
                this.state.isESTEnabled,
                this.state.isTWSEnabled,
                this.state.isWASEnabled,
                this.state.hasSomeTeamAssignment
            )
        })

        this.copyToDialogInfoBlock = new InformationBlock()
        this.copyToDialog = new MoveToDialog({
            mode: MoveToDialog.Mode.CUSTOMER_PROJECT,
            titleMessageKey: "task.list.copy_to.task.title",
            buttonMessageKey: "edit_panel.action.copy",
            onMoveCb: (customer, project, settings) => this._onCopyTask(customer.id, project.id, settings),
            onCancelCb: () => this.actions.openLastTaskPanelTab(),
            infoBlock: this.copyToDialogInfoBlock,
            settingsBlock: this.copySettingsBlock,
        })

        this.copyToDialogScrollable = new ScrollableContainer(null, this.copyToDialog, {needRefreshOnResize : true}).init(this.$content);
    }

    _initMoveToDialog() {
        this.moveToDialogInfoBlock = new InformationBlock({
            title: messageResource.getMessage('task.list.move_to.task.info_title'),
        })
        this.moveToDialog = new MoveToDialog({
            mode: MoveToDialog.Mode.CUSTOMER_PROJECT,
            titleMessageKey: "task.list.move_to.task.title",
            buttonMessageKey: "edit_panel.action.move",
            onMoveCb: this._onMoveTask,
            onCancelCb: () => this.actions.openLastTaskPanelTab(),
            infoBlock: this.moveToDialogInfoBlock,
        })

        this.moveToDialogScrollable = new ScrollableContainer(null, this.moveToDialog, {needRefreshOnResize : true}).init(this.$content)
        this.moveToDialog.setState({showArchived: true})

        this._initMoveToArchiveConfirmationDialog()
    }

    _initMoveToArchiveConfirmationDialog() {
        this.archivingConfirmation = new MoveToArchivedConfirmationDialog({
            confirmCallback: ({customer, project, withRestore, workflowStatusId}) => {
                this.archivingConfirmationScrollable.hide()
                this._confirmMoveHandler(customer, project, withRestore, withRestore ? null : workflowStatusId)
            },
            cancelCallback: () => {
                this.archivingConfirmationScrollable.hide()
                const moveToDialogState = this.moveToDialog.getState()
                this.moveToDialogScrollable.show()
                this.moveToDialog.setState(moveToDialogState)
            },
        })
        this.archivingConfirmation.setState({
            workflowStatusId: this.state.defaultCompletedStatus.id,
            title: messageResource.getMessage("task.list.move_to.move_to_archived.title.single_task"),
            singleOptionDescription: messageResource.getMessage("task.list.move_to.move_to_archived.can_not_manage_description.task"),
            multiOptionDescription: messageResource.getMessage("task.list.move_to.move_to_archived.can_manage_description"),
            archiveText: messageResource.getMessage("task.list.move_to.move_to_archived.complete_with_status.single_task"),
            restoreText: messageResource.getMessage("task.list.move_to.move_to_archived.restore_target_from_archive.project"),
            restoreNoteText: messageResource.getMessage("task.list.move_to.move_to_archived.restore_target_from_archive.description"),
        })
        this.archivingConfirmationScrollable = new ScrollableContainer(null, this.archivingConfirmation, {needRefreshOnResize: true}).init(this.$content)
    }

    _updateDialogsInfo() {
        this.moveToDialogInfoBlock.setState({
            paragraphs: [
                messageResource.getMessage(this.state.isWASEnabled ? 'task.list.move_to.task.info_paragraph1'
                                                                   : 'task.list.move_to.task.info_paragraph1_was_off'),
                messageResource.getMessage(this.state.isWASEnabled ? 'task.list.move_to.task.info_paragraph2'
                                                                   : 'task.list.move_to.task.info_paragraph2_was_off'),
            ],
        })

        this.copyToDialogInfoBlock.setState({
            paragraphs: [
                messageResource.getMessage(this.state.isWASEnabled ? 'task.list.copy_to.task.info_paragraph'
                                                                   : 'task.list.copy_to.task.info_paragraph_was_off'),
            ],
        })
    }

    _handleManagersRemovedToast(removedUserIds) {
        if (removedUserIds.length === 1) {
            const user = this.state.assignedManagers.find(u => u.id === removedUserIds[0])
            const userName = UserNameFormat.formatFML(user.firstName, user.lastName, user.middleName)
            this.state.isWASEnabled && this.actions.toast(messageResource.getMessage("task.list.toasts.revoke_manage_task_from_user", [userName]))
        } else if (removedUserIds.length > 1) {
            this.state.isWASEnabled && this.actions.toast(messageResource.getMessage("task.list.toasts.n_users_no_longer_manage_task", [removedUserIds.length]))
        }
    }

    _onMoveTask = (customer, project) => {
        if (project.archived && !this.state.completed) {
            this.moveToDialogScrollable.hide()

            const canRestore = customer.archived ? !!this.state.editableCustomersIds[customer.id] : !!this.state.editableProjectsIds[project.id]
            this.archivingConfirmationScrollable.show()
            this.archivingConfirmationScrollable.setState({
                customer: customer,
                project: project,
                withRestoreOption: canRestore,
                workflowStatusId: this.state.defaultCompletedStatus.id,
                title: !canRestore && !this.state.isTWSEnabled
                       ? messageResource.getMessage("task.list.move_to.move_to_archived.title.single_task.cannot_restore.feature_disabled")
                       : messageResource.getMessage("task.list.move_to.move_to_archived.title.single_task"),
                showRestoreNote: customer.archived && project.archived,
            })
        } else {
            this._confirmMoveHandler(customer, project, false, null)
        }
    }

    _confirmMoveHandler(customer, project, forceReopen, workflowStatusId) {
        this.header.actions.hideMenu()
        this.actions.moveTask(customer, project, forceReopen, workflowStatusId, (taskId) => this.callbacks.onTaskMovedCb(taskId))
        this.actions.openLastTaskPanelTab()
    }

    _onCopyTask(customerId, projectId, settings) {
        this.header.actions.hideMenu()
        this.actions.copyTask(customerId, projectId, settings)
        this.actions.openLastTaskPanelTab()
    }

    _handleTabSwitched = (selectedKey, previousKey) => {
        this.archivingConfirmationScrollable.hide()

        this.tabsController.setState({selectedTabKey: selectedKey})

        this.buttons.forEach((button, key) => {
            button.toggleClass('selected', key === selectedKey)
        })

        if (selectedKey === TaskDialogs.MOVE_DIALOG) {
            this.moveToDialogScrollable.update()
        } else if (selectedKey === TaskDialogs.COPY_DIALOG) {
            this.copyToDialogScrollable.update()
        } else if (selectedKey === TaskDialogs.DELETE_DIALOG) {
            this.deleteDialogScrollable.update()
        }

        this.commentsFooter.toggle(this.params.showComments && selectedKey === TasksTabs.DETAILS_TAB)

        //reported tab has no state, need to update scrollable container apart
        if (previousKey === TasksTabs.REPORTED_TAB) {
            this.reportedTimeScrollable.forceUpdate()
        }

        //in order not update details tab
        if (selectedKey === TasksTabs.DETAILS_TAB) {
            this.taskPanelDetailsScrollable.forceUpdate()
        } else {
            this.getTabView(selectedKey).update()
        }
    }

    _getDisabledTooltipText(user) {
        let msg = messageResource.getMessage(
            'assigned_users_editor.managers.disabled_tooltip',
            [
                messageResource.getMessage('common.task'),
                user.firstName,
            ]
        )

        if (user.hasAllAssignments) {
            msg += " " + messageResource.getMessage('assigned_users_editor.managers.disabled_tooltip.entire_scope')
        }  else if (user.hasAllFutureProjectsOfCustomerAssignment) {
            msg += " " + messageResource.getMessage(
                'assigned_users_editor.managers.disabled_tooltip.all_existing_and_future_items_assignment',
                [
                    messageResource.getMessage('common.projects'),
                    messageResource.getMessage('common.customer'),
                ]
            )
        } else if (user.hasCustomerAssignment) {
            msg += " " + messageResource.getMessage(
                'assigned_users_editor.managers.disabled_tooltip.entire_item_assignment',
                [messageResource.getMessage('common.customer')],
            )
        } else if (user.hasProjectAssignment) {
            msg += " " + messageResource.getMessage(
                'assigned_users_editor.managers.disabled_tooltip.entire_item_assignment',
                [messageResource.getMessage('common.project')],
            )
        } else if (user.hasAllFutureTasksOfProjectAssignment) {
            msg += " " + messageResource.getMessage(
                'assigned_users_editor.managers.disabled_tooltip.all_existing_and_future_items_assignment',
                [
                    messageResource.getMessage('common.tasks'),
                    messageResource.getMessage('common.project'),
                ]
            )
        }
        return msg
    }

    _getDisabledTooltipTextAssugnedUsersEditor(user) {
        return messageResource.getMessage(
            'panel.common.cannot_unassign_user.tooltip',
            [
                messageResource.getMessage('common.task'),
                user.firstName
            ])
    }

    _getDisabledTooltipTextAssignedUsersSelector(user) {
        return messageResource.getMessage(
            'assigned_users_editor.work.disabled_tooltip.user_manages_item',
            [
                messageResource.getMessage('common.task'),
            ])
    }

    _reportedTimeSortChangedHandler(header) {
        const newSortedOrder = (header.isAsc()) ? ReportedTimeSortConstants.ASC : ReportedTimeSortConstants.DESC
        this.actions.saveSortingSettings(header.sortBy, newSortedOrder)
        this.actions.loadTimeComments(
            header.sortBy,
            newSortedOrder,
            0
        )
    }

    onHide() {
        this.header.actions.hideMenu();
        this.taskPanelDetails.hideSelectors();
        this.archivingConfirmationScrollable.hide()
    }

    getTabView(tabKey) {
        return this.tabs.get(tabKey)
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/task/TaskPanel.js